<template>
    <section>
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;padding-top: 10px">
        <el-form :inline="true" :model="souchs" @submit.native.prevent>
          <el-form-item>
            <el-input  v-model="searchText"  placeholder="账号 / 姓名 / 企业" style="width:180px;" clearable  @keyup.enter.native="getUser(1)"></el-input>
          </el-form-item>

           <el-form-item>
             <el-select  v-model="typeValue" placeholder="状态" style="width:140px" class="souch_change souch_input" clearable >
              <el-option v-for="item in types" :key="item.value" 
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
           </el-form-item>

           <el-form-item>
             <el-select  v-model="deptId" placeholder="部门" style="width:140px" class="souch_change souch_input" clearable >
              <el-option v-for="item in detpList" :key="item.value" 
                :label="item.deptname" :value="item.id">
              </el-option>
            </el-select>
           </el-form-item>
        
          <el-form-item>
            <el-button type="primary" size="medium" v-on:click="getUser(1)">查询</el-button>
          </el-form-item>
          <el-form-item v-if="userInfo.type == 1">
            <el-button type="primary" size="medium" v-on:click="addList">添加用户</el-button>
          </el-form-item>
        </el-form>
       
      </el-col>

      <!--列表-->
      <el-table  :data="userList" highlight-current-row v-loading="listLoading"  style="width: 100%;" 
        :header-cell-style="getRowClass" @selection-change="selsChange" @sort-change="handleSortChange">
        <el-table-column type="selection" width="55" :selectable='selectInit'>
			  </el-table-column>
        <el-table-column type="index" :index="indexMethod" label="序号" width="80">
          <template slot-scope="scope">
              <span>{{(pageNumber - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="账号" min-width="140" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="name" label="姓名" min-width="100" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="point" label="积分" min-width="100" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="company" label="企业" min-width="200" sortable="custom" show-overflow-tooltip>
        </el-table-column>
      
        <el-table-column prop="deptname" label="部门" min-width="140" sortable="custom" show-overflow-tooltip>
           <template slot-scope="scope">
              <span>{{ scope.row.deptname || '-' }}</span>
          </template>
        </el-table-column>
        
        <el-table-column prop="invitestatusname" label="状态" min-width="120" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        
        <el-table-column label="操作" min-width="200" style="text-algin:center">
          <template slot-scope="scope">
            <span class="operate">
              <el-tooltip effect="dark" content="删除" placement="top" v-if="!scope.row.delShow">
                  <span class="dnnfont icondelete"  @click="batchRemove(scope.$index, scope.row)"></span>
              </el-tooltip>
             <span class="dnnfont icondelete icon-disabled" v-else  ></span>
            </span>
            <!-- <el-button type="danger" :disabled="scope.row.delShow" plain size="small" @click="batchRemove(scope.$index, scope.row)">移除</el-button> -->
           </template>
        </el-table-column>
      </el-table>
      <el-col :span="24" class="toolbar" style="margin-top:10px; padding-bottom: 10px">
        <el-button type="danger" size="small" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>
        <el-pagination 
          layout="sizes, prev, pager, next"
          :page-sizes="[10, 20, 30, 50,100]"
          :current-page="pageNumber" 
          @current-change="handleCurrentChange" 
          @size-change="handleSizeChange"
          :page-size="pageSize" 
          :total="total" 
          style="float:right;">
        </el-pagination>
      </el-col>

      <!--添加界面-->
      <el-dialog class="model-edit" title="添加" :visible.sync="addFormVisible" 
        :close-on-click-modal="false">
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
          <el-form :inline="true" :model="souchs2" @submit.native.prevent>
             <el-form-item>
              <el-select v-model="value2" placeholder="请选择" @change="changeSouch2"  style="width:120px;">
                <el-option v-for="item in optionsSouch2" :key="item.value"  
                  :label="item.label" :value="item.value">
                </el-option>
              </el-select>
             </el-form-item>
            <el-form-item>
              <el-input v-show="disSouch2" v-model="proName2" style="width:200px;"  @keyup.enter.native="getComUser(1)"></el-input>
              <!-- <el-select v-show="disinvit2" v-model="souchs2.invitValue" placeholder="请选择" style="width:200px;" clearable >
                <el-option v-for="item in inviValues" :key="item.value" 
                  :label="item.label" :value="item.value">
                </el-option>
              </el-select> -->
              <el-select v-show="disSofttype2" v-model="souchs2.softtype" placeholder="请选择" style="width:200px;" clearable >
                <el-option v-for="item in softtypes" :key="item.value" 
                  :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-date-picker v-show="disTime1" style="width:200px;"  v-model="souchs2.fromtime" format="yyyy-MM-dd" 
                  value-format="yyyy-MM-dd" type="date" placeholder="开始日期时间"> 
              </el-date-picker>
              <el-date-picker v-show="disTime2" style="width:200px;"  v-model="souchs2.totime" format="yyyy-MM-dd" 
                value-format="yyyy-MM-dd" type="date" placeholder="结束日期时间"> 
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="medium" v-on:click="getComUser(1)">查询</el-button>
            </el-form-item>
          </el-form>
          <el-tag :key="tag2" v-for="tag2 in dynamicTags2" closable 
            :disable-transitions="false" @close="handleClose2(tag2)"> 
              {{tag2}} 
          </el-tag>
          <el-button v-if="dynamicTags2!=''" class="button-new-tag" size="small" @click="delTags2">清除标签</el-button>
        </el-col>
        
        <!--用户列表-->
        <el-table  :data="companyList" highlight-current-row   style="width: 100%;" @selection-change="selsChange2"
         ref="companyList" :header-cell-style="getRowClass" @current-change="handleSelectionChange" >
          <el-table-column type="selection" width="50">
          </el-table-column>
          <el-table-column prop="phone" label="账号" min-width="130" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="name" label="姓名" min-width="100" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="softtype" label="软件类型"  min-width="120" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="company" label="企业" min-width="160" show-overflow-tooltip>
          </el-table-column>
        </el-table>
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding:10px 0;">
         
          <!-- <el-button style='position:relative;top: -3px;' type="text"  @click.native="handleChange">全部</el-button> -->
          <el-pagination 
            layout="sizes, prev, pager, next"
            :page-sizes="[10, 20, 30, 50,100,'全部']"
            :page-size="pageSize2"
            :total="total2" 
            :current-page="pageNumber2"
            @current-change="handleCurrentChange2" 
            @size-change="handleSizeChange2"
            style="float:right;">
          </el-pagination>
        </el-col>
        <div slot="footer" class="dialog-footer" style="text-align:center">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>
    </section>
</template>
<script>
import { mapGetters } from 'vuex'
import { API__code,API_userCom,API_User,API_Admin} from '../../../api/index.js'
export default {
  inject:['reload'],
  data(){
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else {
        // const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        const reg = /^1[3-9]\d{9}$/
        console.log(reg.test(value));
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号'));
        }
      }
    };
    return{
      searchText:'',
      deptId: '',
      detpList: [],

      inviValues:[],
      softtypes:[],
      checkUserId:'',
      checkUserIdOld:'',
      pageSize2:10,
      pageNumber2:1,
      total2:1,
      companyList:[],
      disSofttype2:false,
      disSouch2:true,
      // disinvit2:false,
      disTime1:false,
      disTime2:false,
      proName2:"",
      dynamicTags2: [],
      optionsSouch2: [
        {value: '账号',label: '账号'}, 
        {value: '姓名',label: '姓名'},
        {value: '企业',label: '企业'},
        {value: '软件类型',label: '软件类型'},
        // {value: '邀请状态',label: '邀请状态'},
        {value: '开始日期',label: '开始日期'},
        {value: '结束日期',label: '结束日期'},
      ],
      value2: '',
      souchs2:{
        name:'',
        phone:'',
        company:'',
        invitestatus:'',
        softtype:'',
        fromtime:'',
        totime:'',
      },

      disSouch:true,
      disType:false,
      souchs:{
        phone:'',
        name:'',
        company:'',
        invitestatusname:'',
      },
      proName:'',
      typeValue:'',
      types: [
        {value: '1',label: '邀请中'}, 
        {value: '2',label: '邀请通过'},
      ],
      options: [
        {value: '账号',label: '账号'}, 
        {value: '姓名',label: '姓名'},
        {value: '企业',label: '企业'},
        {value: '状态',label: '状态'},
      ],
      value: '',
      dynamicTags:[],

      addFormVisible:false,
      addLoading:false,
      addForm:{},
      addFormRules: {
        phone: [
          {validator: checkPhone, trigger: 'blur'}
        ]
      },
      userList:[],
      listLoading:false,
      pageSize: 20,
      pageNumber:1,
      total:0,
      
      token:'',
      checkCode:'',
      id:'',
      companymanageid:'',
      sels:[],
      sels2:[],
      orderType:'',
      orderStr:"",
    }
  },

  computed: {
    ...mapGetters(['userInfo', ]),
  },

  methods:{
    handleSelectionChange:function(row) {
      this.flag = true;
      this.userList.forEach(item => {
        if (item.id !== row.id) {
           item.checked = false;
        }
        if(item.id == row.id){
          item.checked = true;
        }
      });
      if(row.name  == null){
        row.name = "";
      }
      if(row.phone == null){
        row.phone = "";
      }
      this.checkUserId = row.id;
      this.checkUserIdOld = row.id;
    },
    changeSouch2:function(val){
      this.disSouch2=false;
      // this.disinvit2=false;  
      this.disSofttype2=false;
      this.disTime1=false;
      this.disTime2=false;
      if(val == "账号"){
        this.proName2 = this.souchs2.phone;
        this.disSouch2 = true;
      }else if(val == "姓名"){
        this.proName2 = this.souchs2.name;
        this.disSouch2 = true;
      }else if(val == "企业"){
        this.proName2 = this.souchs2.company;
        this.disSouch2 = true;
      }else if(val == "软件类型"){
        this.disSofttype2 = true;
      }else if(val == "开始日期"){
        this.disTime1 = true;
      }else if(val == "结束日期"){
        this.disTime2 = true;
      }
      // else if(val == "邀请状态"){
      //   this.disinvit2 = true;  
      // }
      
    },
    handleClose2(tag) {
      if(tag == "账号"){
        this.souchs2.phone = '';
        if(this.value2 == "账号"){
          this.proName2 = '';
        }
      }
      if(tag == "姓名"){
        this.souchs2.name = '';
        if(this.value2 == "姓名"){
          this.proName2 = '';
        }
      }
      if(tag == "企业"){
        this.souchs2.company = '';
        if(this.value2 == "企业"){
          this.proName2 = '';
        }
      }
      if(tag == "软件类型"){
        this.souchs2.softtype = "";
      }
      // if(tag == "邀请状态"){
      //   this.souchs2.invitValue = "";
      // }
      if(tag == "开始日期"){
        this.souchs2.fromtime ="";
      }
      if(tag == "结束日期"){
        this.souchs2.totime ="";
      }
      this.dynamicTags2.splice(this.dynamicTags2.indexOf(tag), 1);
    },
    delTags2:function(){
      this.souchs2 = {};
      this.proName2 = '';
      this.value2 = '';
      this.dynamicTags2 = [];
      this.getComUser();
    },
    // handleChange(){
    //   this.getComUser(9);
    // },
    handleCurrentChange2(val) {
      this.pageNumber2 = val;
      this.getComUser();
    },
    handleSizeChange2(val) {
      if(!val){
        this.getComUser(9);
      }else{
        this.pageSize2 = val;
		  	this.getComUser();
      }
			
		},
    getComUser:function(val){
      let _this = this;
      if(this.value2 == "账号"){
        this.souchs2.phone = this.proName2;
      }
      if(this.value2 == "企业"){
        this.souchs2.company = this.proName2;
      }
      if(this.value2 == "姓名"){
        this.souchs2.name = this.proName2;
      }
      var flag2 = true;
      if(val == 1){
        if(this.value2){
          if(this.dynamicTags2.length > 0){
            for(var i=0;i<this.dynamicTags2.length;i++){
              if(this.value2 == this.dynamicTags2[i]){
                flag2 = false;
              }
            }
          }
          if(flag2){
            this.dynamicTags2.push(this.value2);
          }
        }
      }
      let param;
      if(val == 9){
        param = {
          token:this.token,
          checkCode:this.checkCode,
          // searchStr:this.souchs2.name,
          username:this.souchs2.name,
          phone:this.souchs2.phone,
          company:this.souchs2.company,
          registertimefrom:this.souchs2.fromtime,
          registertimeto:this.souchs2.totime,
          softtype:this.souchs2.softtype,
          invitestatus:'0',
         
        }
      }else {
        param = {
          token:this.token,
          checkCode:this.checkCode,
          pageNumber:this.pageNumber2,
          pageSize:this.pageSize2,
          listType:'page',
          userType:'',
          // searchStr:this.souchs2.name,
          username:this.souchs2.name,
          phone:this.souchs2.phone,
          company:this.souchs2.company,
          registertimefrom:this.souchs2.fromtime,
          registertimeto:this.souchs2.totime,
          softtype:this.souchs2.softtype,
          invitestatus:'0',
        }
      }
      // let param = {
      //   token:this.token,
      //   checkCode:this.checkCode,
      //   pageNumber:this.pageNumber2,
      //   pageSize:this.pageSize2,
      //   listType:'page',
      //   userType:'',
      //   // searchStr:this.souchs2.name,
      //   username:this.souchs2.name,
      //   phone:this.souchs2.phone,
      //   company:this.souchs2.company,
      //   registertimefrom:this.souchs2.fromtime,
      //   registertimeto:this.souchs2.totime,
      //   softtype:this.souchs2.softtype,
      //   invitestatus:'0',
      // }

      API_User.userList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data.list){
            _this.total2 = res.data.data.totalRow;
            _this.companyList = res.data.data.list;
          }else{
            _this.companyList = res.data.data;
            _this.total2 = 1;
            _this.pageNumber2 = 1;
          }
        }else{
          _this.$message.error(res.data.message);
          if(res.data.code == 403){
            _this.$router.push({path: 'loginAdmin'});
          }
        }
      }).catch(err =>{
        _this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    handleSortChange:function(val){
      if(val){
        if(val.prop == "name"){
          this.orderStr = "namepx";
        }else if(val.prop == "phone"){
          this.orderStr = "phonepx";
        }else if(val.prop == "invitestatusname"){
          this.orderStr = "invitestatusnamepx";
        }else if(val.prop == "point"){
          this.orderStr = "pointpx";
        }else if(val.prop == "company"){
          this.orderStr = "companypx";
        }
        else if(val.prop == "deptname"){
          this.orderStr = "deptpx";
        }
        if(val.order == "descending"){
          this.orderType = "desc";
        }else{
          this.orderType = "asc";
        }
      }
      this.getUser();
    },
    
    batchRemove:function(index,row){
      this.$confirm('确认删除选中记录吗？', '提示', {
        type: 'warning'
      }).then(() => {
        var ids;
        if(row){
          ids = row.id;
        }else{
          ids = this.sels.map(item => item.id).toString();
        }
        this.listLoading = true;
        let para = { 
          token:this.token,
          checkCode:this.checkCode,
          companyid:this.$route.query.companyId,
          userids:ids,
        };
        API_userCom.delComUserList(para).then((res) => {
          if(res.data.code == API__code.SUCCESS){
            this.listLoading = false;
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getUser();
          }else{
            this.$message.error(res.data.message);
            if(res.data.code == 403){
              this.$router.push({path: 'login'});
            }
          }
        }).catch(err =>{
          this.$message.error('数据丢失，试试重新登陆！');
        });
      });
    },
    selsChange: function (sels) {
			this.sels = sels;
    },
    selsChange2: function (sels) {
			this.sels2 = sels;
    },
    selectInit:function(row,index){
      if(row.companymanageid || (row.deptList && row.deptList.length > 0)){
        return 0;//不可勾选
      }else{
        return 1;//可勾选
      }
    },
    delTags:function(){
      this.souchs = {},
      this.value = '';
      this.typeValue = '';
      this.proName = '';
      this.dynamicTags = [];
      this.getUser();
    },
    handleClose(tag) {
      if(tag == "账号"){
        this.souchs.phone ="";
        if(this.value == "账号"){
          this.proName = '';
        }
      }
      if(tag == "姓名"){
        this.souchs.name ="";
        if(this.value == "姓名"){
          this.proName = '';
        }
      }
      if(tag == "企业"){
        this.souchs.company="";
        if(this.value == "企业"){
          this.proName = '';
        }
      }
      if(tag == "状态"){
        this.souchs.invitestatusname ="";
        this.typeValue = '';
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    changeSouch:function(val){
      if(val == "账号"){
        this.proName = this.souchs.phone;
        this.disSouch = true;
        this.disType = false;
      }else if(val == "姓名"){
        this.proName = this.souchs.name;
        this.disSouch = true;
        this.disType = false;
      }else if(val == "企业"){
        this.proName = this.souchs.company;
        this.disSouch = true;
        this.disType = false;
      }else if(val == "状态"){
        this.typeValue = this.souchs.invitestatusname;
        this.disSouch = false;
        this.disType = true;
      }
    },
    addSubmit:function(addForm){
      var ids = this.sels2.map(item => item.id).toString();
      let param ={
          token:this.token,
          checkCode:this.checkCode,
          companyid:this.$route.query.companyId,
          userids:ids,
      }
      API_userCom.addComUserList(param)
        .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.$message({
            message: '添加成功',
            type: 'success'
          });
          this.addFormVisible = false;
          this.getUser();
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'login'});
          }
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    addList:function(){
      this.getComUser();
      this.addFormVisible = true;
    },
    indexMethod(index) {
      return (index+1)+(this.pageNumber-1)*pageSize;
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == 0) {
          return "background:#F5F7FA";
      } else {
          return "";
      }
    },
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getUser();
    },
    handleSizeChange(val) {
			this.pageSize = val;
			this.getUser();
		},
    getUser:function(val){
      if(this.value == "账号"){
        this.souchs.phone = this.proName;
      }
      if(this.value == "姓名"){
        this.souchs.name = this.proName;
      }
      if(this.value == "企业"){
        this.souchs.company = this.proName;
      }
      if(this.value == "状态"){
        this.souchs.invitestatusname = this.typeValue;
      }
      var flag = true;
      if(val == 1){
        if(this.value){
          if(this.dynamicTags.length > 0){
            for(var i=0;i<this.dynamicTags.length;i++){
              if(this.value == this.dynamicTags[i]){
                flag = false;
              }
            }
          }
          if(flag){
            this.dynamicTags.push(this.value);
          }
        }
      }
      let _this = this;
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        pageNumber:this.pageNumber,
        pageSize:this.pageSize,
        listType:'page',
        companyid:_this.$route.query.companyId,
        // companyid:this.companymanageid,
        company:this.souchs.company,
        phone:this.souchs.phone,
        username: this.souchs.name,
        // invitestatus:this.souchs.invitestatusname,
        orderType:this.orderType,
        orderStr:this.orderStr,
        invitestatus: this.typeValue,
        searchText: this.searchText,
        deptid: this.deptId
      }
      this.listLoading = true
      API_userCom.userList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data){
            for(var i=0;i<res.data.data.list.length;i++){
              if(res.data.data.list[i].companymanageid || (res.data.data.list[i].deptList && res.data.data.list[i].deptList.length > 0)){
                res.data.data.list[i].delShow = true;
              }else{
                res.data.data.list[i].delShow = false;
              }
            }
            _this.userList = res.data.data.list;
            _this.total = res.data.data.totalRow;
          }
        }else{
          _this.$message.error(res.data.message);
          if(res.data.code == 403){
            _this.$router.push({path: 'login'});
          }
        }
        this.listLoading = false
      }).catch(err =>{
        this.listLoading = false
        _this.$message.error('数据丢失，试试重新登陆！');
      })
    },

    // 获取当前登录人所在部门
    getDeptList() {
      let param = {
        token:this.token,
        checkCode: this.checkCode,
        companyid: this.$route.query.companyId,
      }
       API_userCom.getDepartList(param).then((res) =>{
        if(res.data.code == 200) {
          this.detpList = res.data.data;
          // this.deptId = this.detpList.length > 0? this.detpList[0].id: ''
        }
      }).catch(err =>{
        _this.$message.error('数据丢失，试试重新登陆！');
      })
    },
    
    handledel:function(index,row){
      let param ={
        id:row.id
      }
    },
    //读取cookie
    getCookie: function() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('='); //再次切割
          //判断查找相对应的值
          if (arr2[0] == 'dnnyptadmin_token') {
              this.token = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
              this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
              this.id = arr2[1];
          }
        }
      }
    },
    getCode1:function(){
      let _this = this;
      let param = {
        token:this.token,
        checkCode:this.checkCode,
      }
      API_Admin.UserList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          // this.yhlx = res.data.data;
          _this.yhlx=[];
          _this.softtypes = [];
          for(var i=0;i<res.data.data.length;i++){
            var jsons = {"value":res.data.data[i].code,"text":res.data.data[i].name}
            _this.yhlx.push(jsons);
            var json = {'value': res.data.data[i].code,'label': res.data.data[i].name}
            _this.softtypes.push(json);
          }
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
      });
    },
    getCode:function(){
      let _this = this;
      let param ={
        token:this.token,
        checkCode:this.checkCode,
        type:7,
      }
      API_User.getCode(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          _this.inviValues = [];
          for(var i=0;i<res.data.data.length;i++){
            var jsons = {"value":res.data.data[i].code,"label":res.data.data[i].name}
            _this.inviValues.push(jsons);
          }
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
      });
    },

  },
  created(){
    this.getCookie();
    this.getDeptList()
  },
  mounted(){
    this.getUser();
    this.getCode();
    this.getCode1();
  }
}
</script>
<style scoped>
.el-select {
    display: inline-block;
    position: relative;
    width: 115px;
}
.el-select {
    display: inline-block;
    position: relative;
    width: 115px;
}
.el-tag + .el-tag {
    margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// Companyed.vue?6a7193a4